/**
 * ClassicPage — play the daily / session classic Wordle game.
 */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GameGrid } from '../components/Grid';
import { Keyboard } from '../components/Keyboard';
import { Toast } from '../components/Toast';
import { ResultModal } from '../components/Modal';
import { startClassicGame } from '../store/slices/gameSlice';

const ClassicPage = () => {
  const dispatch = useDispatch();
  const dictLoaded = useSelector((state) => state.dictionary.loaded);

  useEffect(() => {
    if (dictLoaded) {
      dispatch(startClassicGame());
    }
  }, [dispatch, dictLoaded]);

  if (!dictLoaded) {
    return (
      <div className="flex items-center justify-center flex-1">
        <p className="text-lg text-gray-500 dark:text-gray-400 animate-pulse">
          Sözlük yükleniyor...
        </p>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center flex-1 w-full max-w-md mx-auto py-4 sm:py-8 px-2">
      {/* Mode indicator */}
      <div className="text-center mb-4 sm:mb-8">
        <span className="text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-widest">
          Klasik Mod
        </span>
      </div>

      {/* Grid container with fixed/intrinsic sizing to keep it central */}
      <div className="flex-1 flex flex-col items-center justify-center min-h-0">
        <GameGrid />
      </div>

      {/* Keyboard */}
      <div className="w-full pt-4 pb-2">
        <Keyboard />
      </div>

      {/* Toast messages */}
      <Toast />

      {/* Win/Lose modal */}
      <ResultModal />
    </div>
  );
};

export default ClassicPage;
